import classNames from 'classnames';
import { isAfter } from 'date-fns';
import { useTranslation } from 'next-i18next';
import DatePicker from 'react-datepicker';
import { Controller, useFormContext } from 'react-hook-form';

import { IContracts } from '@/modules/workforce/Contracts/types';
import { InputLabel, Typography } from '@/shared/components/atoms';
import { getDateFormat } from '@/shared/components/molecules/CustomDatePicker/logic';

import Calender from '~/images/shared/calender.svg';

const ContractDate = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const { watch, control, resetField } =
    useFormContext<IContracts.IAddContractSchema>();

  const startDate = watch('startDate');
  const endDate = watch('endDate');
  const status = watch('status');
  const hasMismatch = watch('hasUnitMismatch');

  const startDateDisabled = hasMismatch || (status && status !== 'Upcoming');
  const endDateDisabled = hasMismatch || (status && status === 'Past');

  return (
    <div className='w-full'>
      <InputLabel className='block' label={t('Contract Duration')} />
      <div className='flex h-56 items-center justify-between rounded-xl border-xs border-grey-200 px-16'>
        <div className='flex'>
          <Controller
            name='startDate'
            control={control}
            render={({ field: { onChange } }) => (
              <DatePicker
                wrapperClassName='relative'
                locale={language}
                selected={startDate}
                onChange={(date) => {
                  if (date) {
                    onChange(date);
                    if (isAfter(date, endDate)) {
                      resetField('endDate', { defaultValue: null });
                    }
                  }
                }}
                disabled={startDateDisabled}
                minDate={new Date()}
                customInput={
                  <Typography
                    className={classNames(
                      'whitespace-nowrap',
                      startDateDisabled && 'opacity-5'
                    )}
                    variant='body1'
                  >
                    {startDate
                      ? getDateFormat(startDate, language, 'dd/MM/yyyy')
                      : t('startTime')}
                  </Typography>
                }
              />
            )}
          />
          <span className='text-16 mx-1'>-</span>
          <Controller
            name='endDate'
            control={control}
            render={({ field: { onChange } }) => (
              <DatePicker
                wrapperClassName='relative'
                locale={language}
                selected={endDate}
                minDate={startDate}
                disabled={endDateDisabled}
                onChange={(date) => {
                  if (date) onChange(date);
                }}
                placeholderText='dd/mm/yyyy'
                customInput={
                  <Typography
                    variant='body1'
                    className={classNames(
                      'whitespace-nowrap',
                      endDateDisabled && 'opacity-5'
                    )}
                  >
                    {endDate
                      ? getDateFormat(endDate, language, 'dd/MM/yyyy')
                      : t('endTime')}
                  </Typography>
                }
              />
            )}
          />
        </div>
        <span className='text-primary-default'>
          <Calender />
        </span>
      </div>
    </div>
  );
};

export default ContractDate;
